const HTML_TAG_REGEX = /<\/?[a-z][\s\S]*>/i;

const normalizeTemplateText = (value = "") =>
  value
    .replace(/\r\n/g, "\n")
    .replace(/\u00a0/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

const convertNodeToTemplateText = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent || "";
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return "";
  }

  const childContent = Array.from(node.childNodes)
    .map(convertNodeToTemplateText)
    .join("");

  switch (node.tagName) {
    case "BR":
      return "\n";
    case "A": {
      const href = node.getAttribute("href") || "";
      const label = childContent.trim() || href;
      return `[${label}](${href})`;
    }
    case "B":
    case "STRONG":
      return `**${childContent.trim()}**`;
    case "I":
    case "EM":
      return `*${childContent.trim()}*`;
    case "U":
      return `[u]${childContent.trim()}[/u]`;
    case "P":
    case "DIV":
      return `${childContent.replace(/\n+$/g, "")}\n\n`;
    case "LI":
      return `${childContent.replace(/\n+$/g, "")}\n`;
    default:
      return childContent;
  }
};

export const normalizeTemplateBodyForEditor = (value = "") => {
  if (!value || !HTML_TAG_REGEX.test(value) || typeof DOMParser === "undefined") {
    return value;
  }

  const parser = new DOMParser();
  const documentFragment = parser.parseFromString(`<div>${value}</div>`, "text/html");
  const wrapper = documentFragment.body.firstElementChild;

  if (!wrapper) {
    return value;
  }

  const plainTextValue = Array.from(wrapper.childNodes)
    .map(convertNodeToTemplateText)
    .join("");

  return normalizeTemplateText(plainTextValue) || value;
};
